// extracted by mini-css-extract-plugin
module.exports = {"images":"HeroImages_images__xxvkc","image1":"HeroImages_image1__ffljK","image2":"HeroImages_image2__BTPhP","image3":"HeroImages_image3__OBfhY"};